import { Card, Col, Row, Typography,Image } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import constants from "../Redux/constants";
import client from '../../images/client.svg';
import consultant from '../../images/consultant.svg';


const AccountTypeCard = (props) => {
  let history = useHistory();
  const register = () => {
    props.accountType === constants.roles.client
      ? history.push("/registration/client")
      : history.push("/registration/consultant");
  };
  return (
    <Col xs={{span:24}} xl={{span:20}} data-testid={props.id}>
      <Card hoverable onClick={register} style={{width:'100%',marginBottom:'2vh'}}>
          <Row>
            <Col xs={{span:12,offset:4}}>
            <Typography.Title level={5}>
              {props.accountType}
            </Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col xs={{span:2,offset:0}} style={{paddingTop:'1vh'}}>
              {
                props.accountType === constants.roles.client
                ?
                <Image preview={false} src={client}></Image>
                :
                <Col>
                <Image preview={false} src={consultant}></Image>
                </Col>
              }
            </Col>
            <Col xs={{span:14,offset:2}}>
            <Typography.Paragraph>
            {props.accountDescription}
            </Typography.Paragraph>
            </Col>
            <Col xs={{span:2,offset:2}} style={{paddingTop:'1vh'}}>
            <ArrowRightOutlined/>
            </Col>
          </Row>
      </Card>
    </Col>
  );
};

export default AccountTypeCard;
